import { SET_TOP_SUPPORT_TOPIC_DATA } from "constants-lib/actionTypes"

export const setTopSupportTopicData = (payload) => (dispatch) =>
  dispatch({
    type: SET_TOP_SUPPORT_TOPIC_DATA,
    payload,
  })
